module.exports = __webpack_public_path__ + "img/newsImg12-17.2e955646.png";